import React, { Component } from 'react';
import moment from "moment";
import DatePicker from '../uielements/datePicker';
import { Icon } from 'antd';

const dateFormat = "DD/MM/YYYY";

export default class extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: this.props.value === '' ? moment() : moment(this.props.value, this.props.dateFormat || dateFormat),
      valueStr: this.props.value === '' ? moment().format(this.props.dateFormat || dateFormat) : this.props.value,
      editable: true
    };
  }

  handleChange = moment => {

  };
  check = () => {
    this.setState({ editable: false });
    if (this.props.onChange) {
      this.props.onChange(
        this.state.valueStr,
        this.props.columnsKey,
        this.props.index
      );
    }
  };
  edit = () => {
    this.setState({ editable: true });
  };
  render() {
    const { value, valueStr, editable } = this.state;
    return (
      <div className="isoEditData">
        <div className="isoEditDataWrapper">
          <DatePicker
            style={{width: '95%'}}
            allowClear={false}
            format={this.props.dateFormat || dateFormat}
            value={value}
            onChange={(date, dateString) => {
              this.setState({ value: moment(dateString, this.props.dateFormat || dateFormat) , valueStr:dateString });
              if (this.props.onChange) {
                this.props.onChange(
                  dateString,
                  this.props.columnsKey,
                  this.props.index
                );
              }
            }}
          />
        </div>
      </div>
    );
  }
}
